<template>
    <div>
        <div class="row">
            <div class="bkDetails col-lg-12 col-md-7 col-sm-7 col-12">
                <h3 class="m-0" style="font-weight:700">{{ item.title | decoder}}</h3>
            </div>
        </div>
        <div class="row">
            <div class="bkDetails col-lg-8 col-md-7 col-sm-7 col-12">
                <p class="mt-3 mb-4 p-0" style="font-size: 13px;" v-html="$options.filters.decoder(item.text)">
                </p>
               
                <ul class="list-unstyled socials">
                    <li>
                        <a v-bind:href="'https://www.facebook.com/dialog/share?app_id='+social.app_id+'+&href='+url+'&quote='+social.title" target="_blank" rel="noopener" >
                            <i class="fab fa-facebook-square" style="color:#3f51b5"></i>
                        </a>
                    </li>
                    <li>
                        <a v-bind:href="'https://twitter.com/intent/tweet?text='+social.title+'&url='+url" target="_blank" >
                            <i class="fab fa-twitter" style="color:#2196F3"></i>
                        </a>
                    </li>
                    <li>
                        <a v-bind:href="'http://www.linkedin.com/shareArticle?mini=true&url='+url+'&title='+social.title+'&summary='+social.summary" target="_blank"> 
                                <i class="fab fa-linkedin" style="color:#0d8bf2"></i>    
                        </a>
                    
                    </li>
                </ul>
            </div>

            <div class="bkImage col-lg-4 col-md-5 col-sm-5 col-12 p-2" v-if="item.hasOwnProperty('image')">
                <img class="mt-3" :src="item.image.src" :alt="item.image.alt" :title="item.image.title" v-if="item.image.hasOwnProperty('src')">
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name:'newsitem',
        props:{
            item:{type:Object,required:true},
            social:{type:Object,required:true}
        },
        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
        
    }
</script>

<style scoped>
    .socials li {
        display: inline-block;
    }
    .socials li i{
        font-size: 35px; 
        margin-right:10px !important;
    }
    .bkDetails .btn1{
        color:white;
        background: #3969bd;
        border-radius: 0px;
        padding: 5px 25px;
        font-size: 12px;
    }
     .bkDetails .btn2{
        color:black;
        background: #fbf000;
        border-radius: 0px;
        padding: 5px 25px;
        margin-top: 10px;
    }
    .bkImage{

    }
    .bkImage img{
        max-width: 230px !important;
    }
    .bkImage .btn{
        border-radius: 0px;
        background:black !important;
        margin:0 auto;
        margin-top:10px;
        padding:5px 25px;
        display: block;
    }
    table{
            font-size: 12px;
            font-weight: 700;   
    }

    @media (max-width:576px){
         .bkImage img{
            margin: 0 auto;
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/overall_layouts/newsitem.vue